import React, { useCallback, useState } from 'react';

import { CommandPalette } from './CommandPalette';
import { useCommandPaletteHotkey } from './useCommandPaletteHotkey';

/**
 * Wires the {@link CommandPalette}'s open/close state to a global ⌘K / Ctrl+K
 * shortcut. Mount once at the admin shell level.
 */
export const CommandPaletteHost: React.FC = () => {
  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen((prev) => !prev), []);
  useCommandPaletteHotkey(toggle);

  return <CommandPalette open={open} onOpenChange={setOpen} />;
};
